module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Katharine Corr, Elizabeth Corr\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v(" Katharine and Elizabeth Corr are sisters and writing partners. They are the authors of the Witch’s Kiss Trilogy and the Solanum Duology. Their novels "), _c('I', [_vm._v("A Throne of Swans")]), _vm._v(" and "), _c('I', [_vm._v("Queen of Gods")]), _vm._v(" have appeared on YA bestseller lists. The Corr sisters grew up in Essex and now live ten minutes away from each other in Surrey with their families. ")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/190Rvo3/image/prevcover.jpg?1725038471826",
      "alt": "This image is the cover for the book Witch's Kiss, The Witch's Kiss Trilogy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Witch's Kiss, The Witch's Kiss Trilogy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("In this YA fantasy romance debut, a teenage girl is about to learn that the only thing more dangerous than being a witch is falling in love.")])]), _c('p', [_vm._v(" Sixteen-year-old Merry is fed up with her feuding family and nonexistent social life. High school is a terrible time to have magic shooting from her fingertips without warning. ")]), _vm._v(" Then Merry meets sweet, sensitive Jack, and can’t resist falling under his spell. There’s just one problem: he’s part of an evil, centuries-old curse that Merry is supposed to break. Is Merry about to lose her heart"), _c('i', [_vm._v(" and")]), _vm._v(" her life? Or will true love’s kiss save the day?\n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0